export const ZIGGEO_API_KEY = '650f4f9786cdbc7b4940c5a06c506d25';

export const DUMMY_TOKENS = ['93566eb4cfb734f7f9f0dd0092a10d61', '24be130265e70dece42181392ad4237d', '835692086d01d6ceb25a6333ae86c172'];



// WEBPACK FOOTER //
// ./src/routes/advisor/routes/Profile/routes/SelfIntro/constants.js